import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, Phone, Mail, MapPin, Clock } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-950 text-white pt-16 pb-8" data-id="element-57" data-mp="32pp6s3i2xx5z">
      <div className="container-custom" data-id="element-58" data-mp="36oo8lf8ildt7">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-59" data-mp="36ppihgdsnu9c">
          {/* Company Info */}
          <div data-id="element-60" data-mp="3ud7gvurkdqla">
            <div className="flex flex-col mb-6" data-id="element-61" data-mp="38h4x8q3ngkf">
              <span className="text-2xl font-bold text-white tracking-tight leading-none" data-id="element-62" data-mp="387drhtbj3d5">
                Brixen
              </span>
              <span className="text-xs font-medium text-blue-400 tracking-widest uppercase mt-0.5" data-id="element-63" data-mp="3lgosmvua2qv1">
                Consulting
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-64" data-mp="29xm06nd2d2ik">
              Structured, compliant, and execution-focused solutions for
              companies operating in the UAE and internationally.
            </p>
            <div className="flex space-x-4" data-id="element-65" data-mp="3lbdecxo1ahnx">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-66" data-mp="3gb8ses4cwuqb">
                <Linkedin className="h-5 w-5" data-id="element-67" data-mp="3v91bfu944199" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-68" data-mp="3q7lo1vjgpinp">
                <Twitter className="h-5 w-5" data-id="element-69" data-mp="81785r1muymo" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-70" data-mp="32w2lsidfaa9">
                <Instagram className="h-5 w-5" data-id="element-71" data-mp="huwiqy10k36t" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-72" data-mp="qt8ibpjuybbe">
            <h3 className="text-lg font-semibold mb-6" data-id="element-73" data-mp="qt01jmkm6lux">Quick Links</h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-74" data-mp="mrwp7a1rz7yg">
              <li data-id="element-75" data-mp="mthjqzo3aqwb">
                <Link to="/" className="hover:text-blue-400 transition-colors" data-id="element-76" data-mp="mptqm1mk46i4">
                  Home
                </Link>
              </li>
              <li data-id="element-77" data-mp="yto5vsomlxsm">
                <Link to="/about" className="hover:text-blue-400 transition-colors" data-id="element-78" data-mp="yuzcs1ddblny">
                  About Us
                </Link>
              </li>
              <li data-id="element-79" data-mp="18ksnl05orwr5">
                <Link to="/industries" className="hover:text-blue-400 transition-colors" data-id="element-80" data-mp="18lbxpup3hgum">
                  Industries
                </Link>
              </li>
              <li data-id="element-81" data-mp="1hmidu2nu0pnc">
                <Link to="/contact" className="hover:text-blue-400 transition-colors" data-id="element-82" data-mp="1mk1s32kj52fa">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-83" data-mp="3od83n6x41ujc">
            <h3 className="text-lg font-semibold mb-6" data-id="element-84" data-mp="3odhs2q2ibtmx">Services</h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-85" data-mp="3tarqgv7vjfmw">
              <li data-id="element-86" data-mp="2afdj5evzdcpu">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-87" data-mp="2afx2n01a495z">
                  Corporate Services
                </Link>
              </li>
              <li data-id="element-88" data-mp="21n1u9xgilxbz">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-89" data-mp="21kfmbwpppft8">
                  Commercial Brokerage
                </Link>
              </li>
              <li data-id="element-90" data-mp="2pcntgkww0cjz">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-91" data-mp="2pc4mfz8rz8kq">
                  Investment Management
                </Link>
              </li>
              <li data-id="element-92" data-mp="2fdf4k6gvpo4h">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-93" data-mp="2fdyh17nrfkb4">
                  Business Setup
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-94" data-mp="2ruxxw68y3kti">
            <h3 className="text-lg font-semibold mb-6" data-id="element-95" data-mp="2rug4dhdo3kpa">Contact Us</h3>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-96" data-mp="2wnhmdy9680d3">
              <li className="flex items-start" data-id="element-97" data-mp="2iv1herwpls9j">
                <MapPin className="h-5 w-5 mr-3 text-blue-500 shrink-0" data-id="element-98" data-mp="2iwcgwfj4gduu" />
                <span data-id="element-99" data-mp="2ntcpax3g1sp4">
                  Iris Bay Tower, 2204, Business Bay, Dubai, UAE
                </span>
              </li>
              <li className="flex items-center" data-id="element-100" data-mp="3bk8cti0va1qk">
                <Phone className="h-5 w-5 mr-3 text-blue-500 shrink-0" data-id="element-101" data-mp="3fl214ci81ijz" />
                <a href="tel:+971042766249" className="hover:text-white transition-colors" data-id="element-102" data-mp="3fj7orml0myri">
                  +971 04 276 6249
                </a>
              </li>
              <li className="flex items-center" data-id="element-103" data-mp="1q6dqafpa48o2">
                <Mail className="h-5 w-5 mr-3 text-blue-500 shrink-0" data-id="element-104" data-mp="1q5m5lzx7zvck" />
                <a href="mailto:info@brixenconsulting.com" className="hover:text-white transition-colors" data-id="element-105" data-mp="1v6052tkr9wyz">
                  info@brixenconsulting.com
                </a>
              </li>
              <li className="flex items-center" data-id="element-106" data-mp="1iml7xv93ovx4">
                <Clock className="h-5 w-5 mr-3 text-blue-500 shrink-0" data-id="element-107" data-mp="1wn5sowykt1t9" />
                <span data-id="element-108" data-mp="1wk9st3364326">Mon–Fri, 9:00 AM – 6:00 PM (GST)</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 mt-8" data-id="element-109" data-mp="13xgoybuhenny">
          <p className="text-xs text-gray-500 text-center mb-6 leading-relaxed max-w-4xl mx-auto" data-id="element-110" data-mp="13vvvyqntfcs7">
            Brixen Consulting FZCO provides corporate services, business
            support, and commercial brokerage/introduction services. We do not
            provide regulated financial advice, banking services, or legal
            advice. Where applicable, services are subject to relevant
            approvals, third-party requirements, and UAE regulations.
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-111" data-mp="g7uozm6ac4ew">
            <p data-id="element-112" data-mp="2gadhkcbxrbti">
              &copy; {currentYear} Brixen Consulting FZCO. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-113" data-mp="2l7need1nmprd">
              <Link to="/terms" className="hover:text-white transition-colors" data-id="element-114" data-mp="2q1hwjc1m2woc">
                Terms & Conditions
              </Link>
              <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-115" data-mp="2v1md122irrek">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}